<div class="input-group has-feedback has-clear">
  <div *ngIf="hasFilters()" class="input-group-prepend c-hand" ngbDropdown placement="bottom-left auto" container="body">
    <div class="input-group-text" ngbDropdownToggle>
      <span class="caret" aria-haspopup="menu" role="button"></span>
    </div>

    <div role="menu" ngbDropdownMenu>
      <ng-container *ngFor="let group of filters">
        <h6 class="dropdown-header">{{ group.title }}</h6>

        <button *ngFor="let filter of group.children" (click)="onFilterClick(filter)" class="dropdown-item">
          <my-global-icon [ngClass]="{ 'no-visible': !isFilterEnabled(filter) }" iconName="tick"></my-global-icon>

          {{ filter.label }}
        </button>
      </ng-container>
    </div>
  </div>

  <input
    type="text" name="table-filter" id="table-filter" i18n-placeholder placeholder="Filter..."
    [(ngModel)]="searchValue"
    (keyup)="onInputSearch($event)"
  >

  <a class="glyphicon glyphicon-remove-sign form-control-feedback form-control-clear" (click)="onResetTableFilter()"></a>
  <span class="sr-only" i18n>Clear filters</span>
</div>
